import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { pcLady } from "../characters/PCLady";
import { vanessa } from "../characters/Vanessa";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V5EndDay2 } from "./V5";
import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { endReplay } from "../../src/shell/endReplay";
import SoundClass from "../../src/shell/Sound";
import { music } from "./sounds";

export const V5AnnSexEvening2 = async (): Promise<any> => {
    mc.talk(`Time to meet Ann.`);
    doTransition(images.v5.AnnRoomEvening_0);
    // SoundClass.startMusic(music.V5AnnMCFirstSex, { shouldPlay: true, loop: true });
    ann.talk(`I'm glad that you came.`);
    mc.think(`Ann in a robe?\nI don't know what Vanessa said to her but I like it.`);
    ann.talk(`So...`);
    ann.talk(`After you left, Vanessa and I had heart-to-heart talk.`);
    ann.talk(`She made me realize some stuff.`);
    mc.talk(`Like what?`);
    ann.talk(`It doesn't matter right now...`);
    ann.talk(`I'll just show you...`);
    ann.talk(`Are you ready?`);
    mc.talk(`Always.`);
    mc.think(`I'll take my clothes off to make it easier for her.`);
    return jump(V5AnnSexEvening3, "V5AnnSexEvening3");
};

export const V5AnnSexEvening3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_1, { transition: true });
    ann.talk(`I bought it just for you. I hope you like it.`);
    mc.talk(`I bet I will.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_2);
    ann.talk(`Here it goes...`);

    ImageClass.setImage(images.v5.AnnRoomEvening_3);
    mc.think(`A small striptease. I like it.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_4);
    mc.think(`Nice ass cheeks. I didn't notice that before.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_5);
    ann.talk(`I hope you like it.`);
    if (mc.properties.alpha >= 5) {

        mc.talk(`I do, but I've seen you like that before.`);
    } else {

        mc.talk(`I do.`);
    }
    ImageClass.setImage(images.v5.AnnRoomEvening_6);
    ann.talk(`I'm going to take this off.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_7);
    mc.think(`Finally.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_8);
    return jump(V5AnnSexEvening3_Question, "V5AnnSexEvening3_Question");
};

export const V5AnnSexEvening3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_8);
    await ann.setQuestion(new Question({ text: `...`, options: { think: false }, key: `v5AnnRoomComplimentedHer` })
        .option({ title: `Compliment her`, key: true })
        .option({ title: `Don't compliment`, key: false }));


    if (Question.globalAnswers.v5AnnRoomComplimentedHer) {
        return jump(V5AnnSexEvening3_Compliment, "V5AnnSexEvening3_Compliment");

    } else {

        return jump(V5AnnSexEvening3_DontCompliment, "V5AnnSexEvening3_DontCompliment");
    }
};


export const V5AnnSexEvening3_Compliment = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_8);
    await mc.set((properties) => {
        properties.annRelationship++;
    });
    mc.talk(`You have amazing breasts.`);
    ann.talk(`Thank you...`);


    return jump(V5AnnSexEvening4, "V5AnnSexEvening4");
};


export const V5AnnSexEvening3_DontCompliment = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_8);
    await mc.set((properties) => {
        properties.annRelationship--;
    });


    return jump(V5AnnSexEvening4, "V5AnnSexEvening4");
};

export const V5AnnSexEvening4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_8);
    ann.talk(`I don't feel comfortable like this...`);
    mc.talk(`Just relax.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_10);
    ann.talk(`You are the first guy who is going to see me completely naked...`);
    mc.talk(`I have no problem with that.`);
    mc.think(`I believe she is not shaved down there...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_11, { duration: 0.7 });
    ann.talk(`So... Now what...?`);
    mc.talk(`Get close to me.`);

    ann.talk(`Ok.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_12);
    mc.talk(`You need to relax.`);
    await empty.set((properties) => {
        properties.tempString = `I know... I need to get used to it.`;
    });

    return jump(AnnRoomEvening_4_Question, "AnnRoomEvening_4_Question");
};

export const AnnRoomEvening_4_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_12);


    await ann.setQuestion(new Question({ text: `${empty.properties.tempString}`, options: { array: `v5AnnSexOptionsArr`, think: false }, key: `v5AnnSexOptions` })
        .option({ title: `Lick her pussy`, key: `lickPussy`, hide: Question.globalAnswers.v5AnnSexOptionsArr?.includes("lickPussy") })
        .option({ title: `Sit on her face`, key: `sitFace`, hide: Question.globalAnswers.v5AnnSexOptionsArr?.includes("sitFace") })
        .option({ title: `Penetrate her pussy`, key: `penetrate` }));


    if (Question.globalAnswers.v5AnnSexOptions == "lickPussy") {

        return jump(AnnRoomEvening_4_Lick, "AnnRoomEvening_4_Lick");
    } else if (Question.globalAnswers.v5AnnSexOptions == "sitFace") {

        if (Game.seenScenarios.includes(`AnnRoomEvening_5_Question`)) {

            mc.talk(`Now it's my turn.`);
            return jump(AnnRoomEvening_5_BJ, "AnnRoomEvening_5_BJ");
        }

        return jump(AnnRoomEvening_4_BJ, "AnnRoomEvening_4_BJ");
    } else {


        mc.think(`She is so wet my cock should slide right in.`);
        return jump(AnnRoomEvening_5_Fuck, "AnnRoomEvening_5_Fuck");
    }
};


export const AnnRoomEvening_4_Lick = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_12);
    mc.talk(`I know how to help you.`);
    ann.talk(`How?`);
    mc.talk(`Open your legs.`);
    doWaitImageByTime(images.v5.AnnRoomEvening_13, null, 0.7);
    ann.talk(`Oh...`);

    return jump(AnnRoomEvening_5, "AnnRoomEvening_5");
};


export const AnnRoomEvening_4_BJ = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_12);
    await mc.set((properties) => {
        properties.alpha++;
    });
    mc.talk(`I know how to help you.`);
    ann.talk(`How?`);
    mc.talk(`You should do something you are already comfortable with.`);
    ann.talk(`Like what?`);

    return jump(AnnRoomEvening_5_BJ, "AnnRoomEvening_5_BJ");
};


export const AnnRoomEvening_5 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_14);
    mc.think(`That's the freshest pussy I ever tasted.`);
    mc.think(`Ann tried to hold herself from moaning.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_15);
    mc.think(`But she couldn't stop herself as I started to rotate my tongue faster and faster.`);
    ann.talk(`${mc.name}... Ahh...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_17);
    mc.think(`She started to push her pelvis harder and harder against my tongue.`);
    mc.think(`I decided to tease her a bit and pushed myself away from her pussy.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_16);
    ann.talk(`Ahh! Faster please!`);
    ann.talk(`Ahh!`);
    mc.think(`She started to shiver as I gave her what she asked for.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_18);
    ann.talk(`Oh my God!!!`);
    ann.talk(`${mc.name}!!!`);
    ann.talk(`You are amazing.`);
    if (!Game.seenScenarios.includes(`AnnRoomEvening_4_BJ`)) {

        return jump(AnnRoomEvening_5_Question, "AnnRoomEvening_5_Question");
    }

    return jump(AnnRoomEvening_5_BJ, "AnnRoomEvening_5_BJ");


};

export const AnnRoomEvening_5_Question = async (): Promise<any> => {
    await empty.set((properties) => {
        properties.tempString = `You don't know how good you make me feel.`;
    });
    return jump(AnnRoomEvening_4_Question, "AnnRoomEvening_4_Question");

};

export const AnnRoomEvening_5_BJ = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnRoomEvening_19);
    ann.talk(`MMM!`);
    if (mc.properties.alpha >= 7 && !Game.seenScenarios.includes(`AnnRoomEvening_4_Lick`)) {

        mc.talk(`Now it's my turn!`);
    } else {

    }
    if (ann.properties.isCorrupted && !Question.globalAnswers.v5SexSessionStoppedVanessa) {
        ImageClass.setImage(images.v5.AnnRoomEvening_22);
        // ann.talk(`I've practiced it with Vanessa.`);
        // ann.talk(`I think I can take it all.`);
        // mc.talk(`Let's put you to the test.`);
        vanessa.talk(`It's bigger than what Vanessa let me practice on...`);
        mc.talk(`Well let's see if it fits.`);
        ImageClass.setImage(images.v5.AnnRoomEvening_74);
        mc.talk(`Ahh...`);
        ImageClass.setImage(images.v5.AnnRoomEvening_20);
        // mc.think(`Fuck! That one lesson with Vanessa is really paying off.`);
        mc.think(`Fuck! Only one session with Vanessa and it's already paying off.`);
        ImageClass.setImage(images.v5.AnnRoomEvening_74);
        ann.talk(`*Slurp*`);
        ImageClass.setImage(images.v5.AnnRoomEvening_20);
        mc.think(`She takes it all like a pro!`);
        ImageClass.setImage(images.v5.AnnRoomEvening_74);
        mc.talk(`Hold it!`);
        ImageClass.setImage(images.v5.AnnRoomEvening_19);
        mc.think(`I should thank Vanessa for that.`);
        mc.think(`I'm ready to fuck her.`);
    } else {
        ImageClass.setImage(images.v5.AnnRoomEvening_74);
        mc.talk(`Yes...`);

        ImageClass.setImage(images.v5.AnnRoomEvening_19);
        ann.talk(`MMM...`);

        ImageClass.setImage(images.v5.AnnRoomEvening_74, { wait: true });

        ImageClass.setImage(images.v5.AnnRoomEvening_75);
        ann.talk(`Stop. I can't. It's too big for me.`);
        if (Question.globalAnswers.v5SexSessionStoppedVanessa) {
            mc.think(`Fuck, maybe I shouldn't have stopped Vanessa.`);
        } else {
            mc.talk(`Didn't you practice it with Vanessa?`);
            ann.talk(`I tried... But I didn't succeed... I'm sorry.`);
        }
        // mc.talk(`Fine.`);
        mc.talk(`It's ok. We'll keep practicing.`);
        mc.think(`I guess I'll just have to try and fuck her.`);
    }


    return jump(AnnRoomEvening_5_Fuck, "AnnRoomEvening_5_Fuck");
};


export const AnnRoomEvening_5_Fuck = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Anim_AnnRoomEveningRubbing.poster, { transition: true });
    mc.talk(`Are you ready?`);
    ImageClass.setAnimation(images.v5.Anim_AnnRoomEveningRubbing);
    ann.talk(`Please be gentle.`);
    mc.think(`She is definitely nervous.`);
    mc.talk(`Just relax Ann. I'll go slow.`);
    ann.talk(`Ah... I feel it...`);
    ann.talk(`Slowly...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_27, { duration: 1 });
    ann.talk(`${mc.name}! Ahh!`);
    mc.think(`She is so tight.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_28);
    mc.talk(`Are you ok?`);
    ann.talk(`Yes, keep going.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_29);
    ann.talk(`Ahh...`);
    if (ann.properties.isCorrupted && Question.globalAnswers.v5ToldVanessaYouMeetAnn && mc.properties.vanessaStatus !== "blackmail") {

        mc.think(`I slowly started penetrating Ann when suddenly...`);
        return jump(V5AnnSexEveningVanessaJoined, "V5AnnSexEveningVanessaJoined");
    }

    ann.talk(`It's inside!`);
    ImageClass.setImage(images.v5.AnnRoomEvening_76);
    ann.talk(`Ahhh.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_29, { wait: true });
    ImageClass.setImage(images.v5.AnnRoomEvening_76, { wait: true });
    ImageClass.setImage(images.v5.AnnRoomEvening_29, { wait: true });
    ImageClass.setImage(images.v5.AnnRoomEvening_76, { wait: true });



    return jump(AnnRoomEvening_5_Fuck_Question, "AnnRoomEvening_5_Fuck_Question");
};

export const AnnRoomEvening_5_Fuck_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_29);
    await mc.setQuestion(new Question({ text: `It feels so good I'm going to cum already.`, options: { think: true }, key: `v5CameOnAnnFace` })
        .option({ title: `Cum on her belly`, key: false })
        .option({ title: `Cum on her face`, key: true }));


    if (Question.globalAnswers.v5CameOnAnnFace) {

        return jump(AnnRoomEvening_5_Fuck_Face, "AnnRoomEvening_5_Fuck_Face");
    } else {

        return jump(AnnRoomEvening_5_Fuck_Belly, "AnnRoomEvening_5_Fuck_Belly");
    }
};

export const AnnRoomEvening_5_Fuck_Belly = async (): Promise<any> => {

    ImageClass.setImage(images.v5.AnnRoomEvening_51);
    mc.talk(`AHHH!`, { wait: 0.5 });
    ImageClass.setImage(images.v5.AnnRoomEvening_52);
    mc.talk(`Damn!`);
    ann.talk(`Oh my, that's a lot. Hehe.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_53_2, { transition: true });
    ann.talk(`We finally did it.`);
    mc.talk(`Finally.`);
    ann.talk(`Was it enjoyable for you?`);
    mc.talk(`Yes. And you?`);
    ann.talk(`It hurt at first, but I got used to it... And it felt pretty good!`);
    ann.talk(`Vanessa said it might hurt at first.`);
    ann.talk(`But I had fun!`);
    mc.talk(`I'm glad.`);


    return jump(AnnRoomEveningEnd, "AnnRoomEveningEnd");
};



export const AnnRoomEvening_5_Fuck_Face = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.alpha++;
    });
    ImageClass.setImage(images.v5.AnnRoomEvening_22, { transition: true });
    ann.talk(`Ah? What are you...?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_23_2, { wait: true });

    return jump(AnnRoomEvening_5_Fuck_Face_Question, "AnnRoomEvening_5_Fuck_Face_Question");
};

export const AnnRoomEvening_5_Fuck_Face_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_24_2);

    await mc.setQuestion(new Question({ text: `Ahh!`, options: { think: false }, key: `v5MadeAnnCleanYourCock` })
        .option({ title: `Make her clean your cock`, key: true })
        .option({ title: `Do nothing`, key: false }));


    if (Question.globalAnswers.v5MadeAnnCleanYourCock) {

        return jump(AnnRoomEvening_5_Fuck_Face_Clean, "AnnRoomEvening_5_Fuck_Face_Clean");
    } else {
        return jump(AnnRoomEvening_5_Fuck_Face_Nothing, "AnnRoomEvening_5_Fuck_Face_Nothing");

    }

};


export const AnnRoomEvening_5_Fuck_Face_Clean = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.alpha += 2;
    });
    await ann.set((properties) => {
        properties.corruption += 2;
    });
    ImageClass.setImage(images.v5.AnnRoomEvening_26_2);
    ann.talk(`MMM!!!`);
    mc.think(`Damn that felt real good.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_54, { transition: true });
    mc.talk(`So, how was it?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_55);
    ann.talk(`It was fine.`);
    ann.talk(`I mean, I need to get used to it.`);
    ann.talk(`I didn't expect that last part...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_54);
    mc.talk(`I know you want to make me feel good.`);
    mc.talk(`That's the best way to do it.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_55);
    ann.talk(`Oh, ok I guess.`);



    return jump(AnnRoomEveningEnd, "AnnRoomEveningEnd");
};

export const AnnRoomEvening_5_Fuck_Face_Nothing = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_54, { transition: true });
    mc.talk(`So, how was it?`);
    ann.talk(`It was nice.`);
    ann.talk(`I mean, it kinda hurt, but I enjoyed it.`);
    ann.talk(`Are you always going to cum on me like that?`);
    mc.talk(`Why not? Don't you like it?`);
    ann.talk(`I don't know... I can get used to it if you like it.`);


    return jump(AnnRoomEveningEnd, "AnnRoomEveningEnd");
};


export const AnnRoomEveningEnd = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`AnnRoomEvening_5_Fuck_Face`)) {

        ImageClass.setImage(images.v5.AnnRoomEvening_55);
    } else {

        ImageClass.setImage(images.v5.AnnRoomEvening_53_2);
    }
    ann.talk(`My parents should be home any minute now...`);
    mc.talk(`Alright. I'll talk to you tomorrow. Bye Ann.`);
    ann.talk(`Bye ${mc.name}.`);

    // SoundClass.stopMusic(music.V5AnnMCFirstSex);
    await endReplay(replayScenesList.v5AnnFirstSex);
    return jump(V5EndDay2, "V5EndDay2");
};

export const V5AnnSexEveningVanessaJoined = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_31, { transition: true });
    //shake?
    // <action type="effector" nb="true" wi="false" effect="shake"/>
    vanessa.talk(`Did you lose your virginity yet?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_30);
    ann.talk(`WHAT?! OH MY GOD! WHAT ARE YOU DOING HERE??? GET OUT!!!`, { method: "Shouting" });
    vanessa.talk(`I'm sorry, are you doing something important?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_32);
    ann.talk(`Vanessa!`, { method: "Shouting" });
    ann.talk(`I'm serious! Get out!`, { method: "Shouting" });
    ImageClass.setImage(images.v5.AnnRoomEvening_37);
    vanessa.talk(`Relax, you will have plenty of time to have sex in the future.`);
    ann.talk(`Didn't you want me to do it already? You are ruining it!`);
    vanessa.talk(`I came to help, I didn't think you would actually go though with it.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_37_2);
    ann.talk(`By the way, your boobs are almost out.`);
    vanessa.talk(`Almost?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_38);
    vanessa.talk(`You are right! Let me fix that.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_39);
    vanessa.talk(`Is that better?`);
    mc.think(`She is nuts.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_40);
    ann.talk(`What are you doing? ${mc.name} is here!`);
    vanessa.talk(`Even better! Let's give him a show.`);
    ann.talk(`A show?!`);
    ImageClass.setImage(images.v5.AnnRoomEvening_41);
    vanessa.talk(`Start by grabbing my tits.`);
    ann.talk(`You are insane.`);
    vanessa.talk(`So?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_44);
    vanessa.talk(`${mc.name} likes it. Looks at his cock.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_43);
    ann.talk(`It was like that before you came...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_44);
    vanessa.talk(`It should have become soft by now.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_42);
    ann.talk(`Whatever...`);
    return jump(V5AnnSexEveningVanessaJoined2, "V5AnnSexEveningVanessaJoined2");
};

export const V5AnnSexEveningVanessaJoined2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_45);

    vanessa.talk(`It hasn't been so long, have you already forgotten what we talked about?`);
    ann.talk(`I didn't... But it was different...`);
    mc.talk(`What did you talk about?`);
    vanessa.talk(`Come on, tell him.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_42);
    ann.talk(`Ahh...`);
    vanessa.talk(`Let me help you.`);
    vanessa.talk(`Funny story... it seems that sweet Ann over here had a naughty dream.`);
    mc.talk(`Really?`);
    vanessa.talk(`Yes. All three of us were in it.`);
    mc.talk(`What were we doing?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_39);
    ann.talk(`Vanessa! I thought you would keep it a secret.`);
    vanessa.talk(`No way! You wouldn't have said anything if you didn't want me to do something about it.`);
    ann.talk(`The only reason I talked was because of that thing you gave me... It made me talk...`);
    vanessa.talk(`I know! That's why I gave it to you in the first place.`);

    mc.talk(`What did you give her?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_42);
    vanessa.talk(`Just something to boost her confidence.`);
    vanessa.talk(`I wanted her to meet with you while still under it's affect, but she took her time.`);
    vanessa.talk(`Luckily I came prepared.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_47, { transition: true });
    mc.think(`Vanessa stood up and took something out of her pocket.`);
    vanessa.talk(`Open your mouth.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_48);
    ann.talk(`Ahhh...`);
    mc.think(`I don't know what Vanessa was giving her, but Ann opened her mouth without hesitating, it's like she was waiting for Vanessa to give it to her already.`);
    vanessa.talk(`I can't believe I'm saying it, but don't swallow.`);
    vanessa.talk(`This time, put it under your tongue.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_49);
    vanessa.talk(`Good girl.`);
    vanessa.talk(`Now, let me get a taste of it.`);

    ImageClass.setImage(images.v5.AnnRoomEvening_50);
    ann.talk(`MMM!`);
    mc.think(`Vanessa jumped on top of Ann... And again, Ann doesn't seem to resist.`);
    if (mc.properties.annLateGF) {

        mc.think(`That must be same pill she put in her drink at the bar.`);
    }

    mc.think(`I would expect that Ann would stop her, but they kept kissing intensely.`);

    ImageClass.setImage(images.v5.AnnRoomEvening_57);
    mc.think(`Vanessa pushed Ann on top of the bed like she was her puppet.`);
    mc.think(`They kept kissing while Vanessa massaged Ann's breasts.`);
    mc.think(`Even though this sight was a huge turn on, I couldn't help but think why now? And why in front of me?`);

    ImageClass.setImage(images.v5.AnnRoomEvening_58);
    vanessa.talk(`You are quiet.`);
    mc.talk(`I'm enjoying the show.`);
    vanessa.talk(`Don't worry, we haven't forgotten about you. Lay down.`);
    mc.think(`Ann entered into a submissive state; she was following Vanessa's commands.`);

    ImageClass.setImage(images.v5.AnnRoomEvening_65, { transition: true });
    mc.think(`I laid on the bed between Vanessa and Ann.`);
    mc.think(`Vanessa looked at me with her usual confident look. But Ann on the other hand laid there like she was waiting for Vanessa to command her.`);

    return jump(V5AnnSexEveningVanessaJoined2_2, "V5AnnSexEveningVanessaJoined2_2");
};

export const V5AnnSexEveningVanessaJoined2_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_59, { duration: 0.7 });
    vanessa.talk(`Let me show you how to do it right.`);
    if (Question.globalAnswers.v4GuidedLateGFAnnOnHJ || Question.globalAnswers.v3HJGuidedAnn) {
        mc.think(`I already guided Ann before, but she was eager to learn it again from Vanessa.`);

    }

    ImageClass.setImage(images.v5.Anim_AnnRoomEveningHJDouble.poster);
    vanessa.talk(`Hold it here.`);
    ImageClass.setAnimation(images.v5.Anim_AnnRoomEveningHJDouble);
    vanessa.talk(`Now, start stroking it slowly.`);
    mc.think(`Realizing how close Vanessa's hand was to my bare cock made me so fucking horny.`);
    mc.think(`All I could think of was how good a double handjob from both of them would feel... But I kept my mouth shut, I didn't want to ruin the mood.`);
    mc.think(`It was enough that Ann was agreeing to all of this as it was.`);
    mc.think(`Vanessa definitely knew what she was doing. She was guiding Ann how to touch in all the right places.`);
    vanessa.talk(`Good girl!`);
    mc.talk(`Ahh...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_59);
    vanessa.talk(`Stop.`);
    vanessa.talk(`You don't want him to cum.`);
    ann.talk(`Why not? He is enjoying it...`);
    vanessa.talk(`Don't forget the real reason why we are all here.`);
    vanessa.talk(`I'll get you ready.`);
    ann.talk(`...`);
    ImageClass.setImage(images.v5.Anim_AnnVanessaRoomEveningLick.poster, { transition: true });
    ann.talk(`Ahh!!`);
    ImageClass.setAnimation(images.v5.Anim_AnnVanessaRoomEveningLick);
    mc.think(`Holy shit.`);
    mc.think(`Vanessa pulled Ann to the edge of the bed and got on her knees.`);
    mc.think(`She started licking her best friend's pussy like it's the last ice cream in the world.`);
    ann.talk(`Oh my! Vanessa! Ahhh...`);
    mc.think(`The pill must have taken affect on Ann.`);
    mc.think(`She wouldn't have let it happen if she was sober.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_58);
    mc.think(`Suddenly Vanessa stopped.`);
    vanessa.talk(`You have no idea how wet she is. You are going to enjoy it.`);
    ImageClass.setImage(images.v5.Anim_AnnRoomEveningRide.poster);
    mc.think(`I laid on the bad and Vanessa guided Ann to go on top of me.`);
    vanessa.talk(`I'm so glad to be here to make sure she won't back off!`);
    ann.talk(`Ahh...`);
    mc.think(`Ann positioned herself so my cock was just at the tip of her vagina.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_70);
    mc.think(`She gave me her usual innocent look, but she looked like she wanted it just as much as I do.`);

    return jump(V5AnnSexEveningVanessaJoined3, "V5AnnSexEveningVanessaJoined3");
};

export const V5AnnSexEveningVanessaJoined3 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.Anim_AnnRoomEveningRide.poster);
    mc.think(`Ann started slowly pushing herself downwards.`);
    ImageClass.setAnimation(images.v5.Anim_AnnRoomEveningRide);
    ann.talk(`Ah...`);
    vanessa.talk(`Finally!`);
    vanessa.talk(`Deeper!`);
    vanessa.talk(`Good girl!`);
    mc.think(`Ann pushed herself down and put my entire cock inside of her vagina.`);
    mc.think(`She was tight and wet at the same time. It felt exactly like I imagined... amazing!`);
    vanessa.talk(`Do you like it?`);
    mc.talk(`Hell yeah.`);
    mc.think(`I could've never imagined that this is how her first time would look like, but I wasn't complaining.`);
    ann.talk(`Ah...`);
    ann.talk(`Oh my God!`);
    mc.talk(`Fuck!`);
    vanessa.talk(`Get off! He is going to cum!`);

    return jump(V5AnnSexEveningVanessaJoined4, "V5AnnSexEveningVanessaJoined4");
};

export const V5AnnSexEveningVanessaJoined4 = async (): Promise<any> => {
    ImageClass.setImage(images.v5.AnnRoomEvening_65, { transition: true });
    mc.think(`Vanessa ordered Ann to get off me and they both laid beside me again.`);
    ann.talk(`He didn't cum...`);
    vanessa.talk(`Of course he didn't, he needs one last push.`);

    ImageClass.setImage(images.v5.AnnRoomEvening_59);
    vanessa.talk(`Grab it.`);
    ImageClass.setImage(images.v5.Anim_AnnRoomEveningHJAnn.poster, { duration: 1 });
    ann.talk(`Now, start stroking it like I showed you.`);
    ImageClass.setAnimation(images.v5.Anim_AnnRoomEveningHJAnn);
    mc.think(`Ann obeyed Vanessa and started stroking my cock by herself.`);
    mc.think(`She definitely learned that from Vanessa. Because it feels so nice.`);
    mc.talk(`Ahh...`);
    ImageClass.setImage(images.v5.AnnRoomEvening_64);
    ann.talk(`Do you like it?`);
    mc.talk(`Yes! I'm going to cum!`);
    vanessa.talk(`What are you doing?! Don't stop! He is close!`);
    ImageClass.setAnimation(images.v5.Anim_AnnRoomEveningHJAnn);
    mc.talk(`Almost!`);
    mc.talk(`Ahh!!`);
    vanessa.talk(`Don't waste it!`);
    ann.talk(`Waste it?`);
    ImageClass.setImage(images.v5.AnnRoomEvening_63);
    mc.talk(`AHH!!`);
    ImageClass.setImage(images.v5.AnnRoomEvening_66, { duration: 0.7, shake: true });
    ann.talk(`MMM!!`);
    mc.think(`Vanessa quickly pushed Ann's head down to my cock.`);
    mc.think(`I felt her mouth wrapping my cock while I kept bursting out the cum I had left over.`);
    mc.think(`I knew she was enjoying it because she kept twisting her tongue around my tip and sucking hard.`);
    vanessa.talk(`Don't swallow it! I want a taste as well.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_67, { transition: true });
    mc.think(`Holy shit, is this a dream?!`);
    mc.think(`Vanessa grabbed Ann and started kissing her with my cum in her mouth.`);
    mc.think(`I knew it was going to be crazy when Vanessa burst through the door, but I didn't expect that. I was drained.`);
    ImageClass.setImage(images.v5.AnnRoomEvening_68);
    mc.talk(`Holy shit. That was great.`);

    // SoundClass.stopMusic(music.V5AnnMCFirstSex);
    await endReplay(replayScenesList.v5AnnFirstSex);
    mc.think(`And the night was still young.`);
    vanessa.talk(`I'm glad you enjoyed it, now you should leave us alone.`);
    mc.talk(`Are you serious?`);
    mc.talk(`Ann?`);
    mc.talk(`...`);
    mc.think(`What the fuck just happened?`);

    return jump(V5AnnSexEveningVanessaJoined5, "V5AnnSexEveningVanessaJoined5");
};

export const V5AnnSexEveningVanessaJoined5 = async (): Promise<any> => {

    ImageClass.setImage(images.v1.Room1);
    pcLady.talk(`"Holy shit" was right!`, { method: "Over Chat" });
    mc.talk(`You were quiet for a long time.`, { method: "On Chat" });
    pcLady.talk(`I didn't want to disturb you, but I'll say it again: HOLY SHIT!`, { method: "Over Chat" });
    pcLady.talk(`I can't believe that's how Ann lost her virginity.`, { method: "Over Chat" });
    mc.talk(`Yup.`, { method: "On Chat" });
    pcLady.talk(`Did you know that's how it was going to go down?`, { method: "Over Chat" });
    mc.talk(`Nope, I had no idea.`, { method: "On Chat" });
    mc.talk(`I figured that Vanessa was going to do something crazy after she sent me that evil emoji.`, { method: "On Chat" });
    mc.talk(`But I had no idea she'd join Ann and I while we were going at it.`, { method: "On Chat" });
    pcLady.talk(`Are you complaining?`, { method: "Over Chat" });
    mc.talk(`Lol! Not at all.`, { method: "On Chat" });
    pcLady.talk(`So what happened next?`, { method: "Over Chat" });
    pcLady.talk(`What did Ann say?`, { method: "Over Chat" });
    mc.talk(`Nothing.`, { method: "On Chat" });
    pcLady.talk(`No way! It doesn't make sense!`, { method: "Over Chat" });
    pcLady.talk(`She said that the pill made her say stuff she didn't plan on saying.`, { method: "Over Chat" });
    mc.talk(`I know, I guess it has a different effect in different situations...`, { method: "On Chat" });
    pcLady.talk(`That's weird but whatever...`, { method: "Over Chat" });
    pcLady.talk(`So you didn't talk about what happened?`, { method: "Over Chat" });
    mc.talk(`We did, the next day.`, { method: "On Chat" });
    pcLady.talk(`So you are telling me, that after all that had happened you just got dressed and left?`, { method: "Over Chat" });
    mc.talk(`Exactly.`, { method: "On Chat" });
    pcLady.talk(`Wow. Just wow.`, { method: "Over Chat" });
    mc.talk(`Vanessa told me to leave and Ann didn't respond. I had no choice.`, { method: "On Chat" });
    pcLady.talk(`Ok ok, so keep going!`, { method: "Over Chat" });
    mc.talk(`I just got home and went to sleep.`, { method: "On Chat" });

    return jump(V5EndDay2, "V5EndDay2");
};


